import React from 'react';
import IconCard from '../../IconCard/IconCard';

import DesktopLayout from '../../DesktopLayout';
import FaqPageFooter from './FaqPageFooter';
import FaqCategoryBlock from './FaqCategoryBlock';
import FaqPageSearchBlock from './FaqPageSearchBlock';
import FaqSearchResultBlock from './FaqSearchResultBlock';
import {useFaqPageContext} from '@assets/contexts/faqPageContext';
import FaqPageCard from './FaqPageCard';
import FaqContactUs from './FaqContactUs';
import FaqPageCardThemeSearch from './FaqPageCardThemeSearch';

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function FaqPageDesktopView({isDesktopPreview = false}) {
  const {
    defaultCategory,
    isPreview,
    keySearch,
    searchQuestions,
    filterCategories,
    selectedCategoryId,
    categories,
    questions,
    handleSelectCategory,
    settings,
    i18n
  } = useFaqPageContext();

  const {contactUs = {}} = settings;
  const pageClass = ['Avada-Faq-Page', isPreview && 'admin', settings.theme]
    .filter(Boolean)
    .join(' ');

  return (
    <DesktopLayout>
      <div className={pageClass}>
        <div
          className={`Avada-Faq_Header ${isPreview &&
            'Avada-Faq_Header-Preview'} ${settings.enabledBanner &&
            (settings.bannerType === 'image' ? 'Avada-Faq_Banner_Image' : 'Avada-Faq_Banner')}`}
          style={{
            '--dynamic-banner-image': `url(${settings.bannerImage})`,
            '--dynamic-banner-color': settings.bannerColor
          }}
        >
          <div className={`Avada-Faq_HeaderTitle ${isPreview && 'Avada-Faq_HeaderTitle-Preview'}`}>
            {i18n('Heading')}
          </div>
          {i18n('Description') && (
            <div
              className={`Avada-Faq_HeaderDescription ${settings.layout === 'card' &&
                'Avada-Faq_HeaderDescription-CardTheme'}`}
            >
              {i18n('Description')}
            </div>
          )}

          {settings.layout === 'card' ? (
            <FaqPageCardThemeSearch isPreview={isPreview} />
          ) : (
            <FaqPageSearchBlock isPreview={isPreview} isMobile={false} />
          )}
        </div>
        {settings.layout === 'card' ? (
          <FaqPageCard settings={settings} isDesktop={true} isDesktopPreview={isDesktopPreview} />
        ) : (
          <div className={`Avada-Faq_Body ${isPreview && 'Avada-Faq_Body-Preview'}`}>
            <div className="Avada-Faq_CategoryList">
              {[defaultCategory, ...categories]
                .filter(x => x.categoryId === 'all' || x.questions?.length > 0)
                .map(category => (
                  <IconCard
                    key={category.categoryId}
                    icon={category.icon}
                    selected={category.categoryId === selectedCategoryId}
                    question={category.question}
                    onClick={() => handleSelectCategory(category.categoryId)}
                  />
                ))}
            </div>
            <div className="Avada-Faq_BodyContainer">
              {keySearch ? (
                <FaqSearchResultBlock searchQuestions={searchQuestions} />
              ) : (
                filterCategories.map(category => (
                  <FaqCategoryBlock key={category.categoryId} {...{category, questions}} />
                ))
              )}
            </div>
          </div>
        )}
        {contactUs.display && <FaqContactUs settings={settings} isDesktop={true} />}

        <FaqPageFooter />
      </div>
    </DesktopLayout>
  );
}
